export const axiosData = {
  getStoreProducts: { url: '/api/products', method: 'get' },
  getUpsertDomains: { url: '/api/domains', method: 'get' },
};
